import Marquee from 'react-fast-marquee';
import NivaLogo from './niva.png';
import ICICIPrudential from './icici-prudential.png';
import Chola from './chola.png';
import IffcoTokio from './iffco-tokio.png';
import Digit from './digit.png';
import Care from './care.png';
import ICICILombard from './icici-lombard.png';
import TataAig from './tata-aig.png';
import RoyalSundaram from './royal-sundaram.png';
import UnitedIndia from './united-india.png';
import BajajAllianz from './bajaj-allianz.png';
import SBIGeneral from './sbi-general.png';
import PNBMetLife from './pnb-metlife.png';
import HDFCLife from './hdfc-life.png';
import Oriental from './oriental.png';
import LIC from './lic.png';
import HDFCErgo from './hdfc-ergo.png';
import Star from './star-health.png';
import Kotak from './kotak.png';
import Nia from './nia.png';
import NewTataAig from './new-tata-aig.png';
import NewHdfcErgo from './new-hdfc-ergo.png';
import Image, { StaticImageData } from 'next/image';
// import { InsurerName } from '@prishapolicy/backend-core/masters';

type HeroRowProps = {
  image: StaticImageData;
  name: string;
};

const row1: HeroRowProps[] = [
  { image: NivaLogo, name: 'Niva Bupa Health Insurance Company Limited' },
  { image: ICICIPrudential, name: 'ICICI Prudential Life Insurance Company' },
  { image: Chola, name: 'Cholamandalam MS General Insurance Company' },
  { image: IffcoTokio, name: 'IFFCO TOKIO General Insurance Company Limited' },
  { image: Digit, name: 'Go Digit General Insurance Limited' },
  { image: Care, name: 'Care Health Insurance Limited' },
  { image: ICICILombard, name: 'ICICI LOMBARD General Insurance Company Limited' },
  { image: TataAig, name: 'Tata AIG General Insurance Company Limited' },
  { image: RoyalSundaram, name: 'Royal Sundaram General Insurance Company Limited' },
];

const row2: HeroRowProps[] = [
  { image: UnitedIndia, name: 'United India Insurance Company Limited' },
  { image: BajajAllianz, name: 'Bajaj Allianz General Insurance Company Limited' },
  { image: SBIGeneral, name: 'SBI General Insurance Company Limited' },
  { image: PNBMetLife, name: 'PNB MetLife India Insurance Company' },
  { image: HDFCLife, name: 'HDFC Life Insurance Company' },
  { image: Oriental, name: 'The Oriental Insurance Company Limited' },
  { image: LIC, name: 'Life Insurance Corporation of India' },
  { image: HDFCErgo, name: 'HDFC ERGO General Insurance Company Limited' },
  { image: Star, name: 'Star Health & Allied Insurance Company Limited' },
  { image: Kotak, name: 'Kotak Mahindra General Insurance Company Limited' },
];

const HeroRow = (props: { data: HeroRowProps[] }) => {
  return (
    <div className="mx-5 flex gap-10">
      {props.data.map((item, idx) => {
        return (
          <div key={idx} style={{ width: 150, height: 50, position: 'relative' }}>
            <Image src={item.image} alt={item.name} height={50} />
          </div>
        );
      })}
    </div>
  );
};

export const HeroTicker = () => {
  return (
    <div className="pt-8 pb-10">
      <Marquee speed={50} gradient={false} pauseOnHover={true} >
        <HeroRow data={row1} />
        <HeroRow data={row1} />
        <HeroRow data={row1} />
      </Marquee>
      <Marquee speed={50} gradient={false} pauseOnHover={true} direction="right" className="mt-8">
        <HeroRow data={row2} />
        <HeroRow data={row2} />
        <HeroRow data={row2} />
      </Marquee>
    </div>
  );
};

export default HeroTicker;

const row1Insurers: HeroRowProps[] = [
  { image: BajajAllianz, name: 'Bajaj Allianz General Insurance Company Limited' },
  { image: ICICILombard, name: 'ICICI LOMBARD General Insurance Company Limited' },
  { image: NewTataAig, name: "Tata AIG General Insurance Company Limited" },
  { image: Nia, name: "the " },
  { image: SBIGeneral, name: 'SBI General Insurance Company Limited' },
  { image: NewHdfcErgo, name: 'HDFC ERGO General Insurance Company Limited' },
];

const row2Insurers: HeroRowProps[] = [
  { image: BajajAllianz, name: 'Bajaj Allianz General Insurance Company Limited' },
  { image: LIC, name: 'Life Insurance Corporation of India' },
  { image: Kotak, name: 'Kotak Mahindra General Insurance Company Limited' },
  { image: Oriental, name: 'The Oriental Insurance Company Limited' },
];

export const InsurersLogoComponent = () => {
  return (
    <div className='px-5 xl:px-15 py-15'>
      <div className='border rounded-sm flex border-grey-200 w-full flex-col'>
        <div className='flex'>
          {row1Insurers.map((ins, idx) =>
            <div className='flex w-full'>
              <div className={`${idx === row1Insurers.length - 1 ? "" : "border-r"} border-grey-200 w-full`} key={idx}>
                <div className='px-5 py-[30px] flex justify-center items-center '>
                  <Image src={ins.image} alt={ins.name} className='object-contain' />
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <div className='flex'>
          {row2Insurers.map((ins, idx) =>
            <div className='flex w-full'>
              <div className={`border-grey-200 w-full ${idx === row1Insurers.length - 1 ? "" : "border-r"}`} key={idx}>
                <div className='px-5 py-[30px] flex justify-center items-center '>
                  <Image src={ins.image} alt={ins.name} className='object-contain' />
                </div>
              </div>
            </div>
          )}
        </div> */}
      </div>
    </div>
  )
}